export const globalGetters = {
  cids: 'cid/cids',
  cid:  'cid/cid'
}

export const getters = {
  cids: state => state.cids,
  cid: state => state.cid
}
